// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
   Label Creator — Premium step wizard
   ============================================= */

/* ── Page shell ── */
.lbl-page {
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  background: #f6f2ea;
  color: #3D1818;
  display: flex;
  flex-direction: column;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  overflow-x: hidden;
}

/* ── Brand bar ── */
.lbl-brand-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 16px 32px;
  background: linear-gradient(135deg, #1a0808 0%, #3D1818 45%, #2a1010 100%);
  border-bottom: 2px solid #c8963a;
  position: relative;
  overflow: hidden;
}
.lbl-brand-bar::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    repeating-linear-gradient(
      90deg,
      transparent 0,
      transparent 40px,
      rgba(212, 165, 116, .04) 40px,
      rgba(212, 165, 116, .04) 41px
    );
  pointer-events: none;
}
.lbl-brand-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.25rem;
  font-weight: 400;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #F7E9D2;
  margin: 0;
  line-height: 1;
}
.lbl-brand-orn {
  color: #D4A574;
  font-size: 1.6rem;
  line-height: 1;
  opacity: .9;
  flex-shrink: 0;
}

/* ── Step indicator ── */
.lbl-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 18px 24px 14px;
  background: linear-gradient(180deg, #fdf9f3 0%, #f9f5ee 100%);
  border-bottom: 1px solid #e2d8c8;
  box-shadow: 0 2px 8px rgba(61, 24, 24, .06);
  position: relative;
}
.lbl-steps::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 5%;
  right: 5%;
  height: 1px;
  background: linear-gradient(90deg, transparent, #D4A574 30%, #D4A574 70%, transparent);
  opacity: .4;
}
.lbl-step-line {
  width: 32px;
  height: 1px;
  background: #ddd5c8;
  flex-shrink: 0;
  transition: background .3s;
}
.lbl-step-line.done { background: linear-gradient(90deg, #D4A574, #c8963a); }

.lbl-step-pill {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 12px;
  border-radius: 24px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  transition: all .25s;
  white-space: nowrap;
}
.lbl-step-pill:hover { background: rgba(212, 165, 116, .1); }
.lbl-step-pill.active {
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  border-color: transparent;
  box-shadow: 0 2px 12px rgba(61, 24, 24, .22), inset 0 1px 0 rgba(255,255,255,.06);
}
.lbl-step-pill.done { border-color: rgba(212, 165, 116, .5); }

.lbl-step-num {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .72rem;
  font-weight: 700;
  background: #e8e0d4;
  color: #5D3A3A;
  transition: all .25s;
  flex-shrink: 0;
}
.lbl-step-pill.active .lbl-step-num {
  background: linear-gradient(135deg, #D4A574 0%, #b8893e 100%);
  color: #fff;
  box-shadow: 0 1px 4px rgba(184, 137, 62, .4);
}
.lbl-step-pill.done .lbl-step-num {
  background: linear-gradient(135deg, #D4A574 0%, #b8893e 100%);
  color: #fff;
}
.lbl-step-label {
  font-size: .76rem;
  font-weight: 500;
  color: #9a8a7a;
  transition: color .25s;
  letter-spacing: .2px;
}
.lbl-step-pill.active .lbl-step-label { color: #F7E9D2; }
.lbl-step-pill.done .lbl-step-label { color: #6D4A2A; }

/* ── Main layout — fills full viewport ── */
.lbl-main {
  display: grid;
  grid-template-columns: 1fr 460px;
  flex: 1;
  min-height: 0;
  width: 100%;
  min-width: 0;
  height: calc(100vh - 70px - 60px - 58px);
}

/* ── Preview area (light elegant) ── */
.lbl-preview-area {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  min-height: 0;
  background:
    radial-gradient(ellipse at 50% 40%, rgba(212, 165, 116, .14) 0%, transparent 65%),
    radial-gradient(ellipse at 80% 80%, rgba(123, 35, 35, .04) 0%, transparent 50%),
    #f3ede0;
  position: relative;
  overflow: hidden;
}
.lbl-preview-area::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    repeating-linear-gradient(
      0deg,
      transparent 0,
      transparent 39px,
      rgba(180, 140, 80, .06) 39px,
      rgba(180, 140, 80, .06) 40px
    ),
    repeating-linear-gradient(
      90deg,
      transparent 0,
      transparent 39px,
      rgba(180, 140, 80, .06) 39px,
      rgba(180, 140, 80, .06) 40px
    );
  pointer-events: none;
}

.lbl-preview-card {
  background: transparent;
  border-radius: 16px;
  width: 100%;
  max-width: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  filter: drop-shadow(0 6px 28px rgba(61, 24, 24, .18)) drop-shadow(0 2px 6px rgba(61, 24, 24, .1));
}

.lbl-svg {
  width: 100%;
  height: 100%;
  display: block;
  user-select: none;
  -webkit-user-select: none;
  touch-action: auto;
}

/* ── Controls panel ── */
.lbl-controls {
  background: linear-gradient(180deg, #fefcf8 0%, #faf6ef 100%);
  border-left: 1px solid #e2d8c8;
  padding: 24px 36px 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  height: 100%;
  box-shadow: -2px 0 12px rgba(61, 24, 24, .04);
  min-width: 0;
  box-sizing: border-box;
}
.lbl-controls::-webkit-scrollbar { width: 5px; }
.lbl-controls::-webkit-scrollbar-track { background: #f0ebe0; }
.lbl-controls::-webkit-scrollbar-thumb { background: linear-gradient(#D4A574, #b8893e); border-radius: 3px; }

.lbl-ctrl-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: #3D1818;
  margin: 0 0 4px 0;
  padding-bottom: 12px;
  position: relative;
  letter-spacing: .5px;
}
.lbl-ctrl-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, #c8963a, #D4A574 50%, transparent);
}

/* ── Panel ── */
.lbl-panel {
  flex: 1;
  padding-top: 14px;
}
.lbl-panel-hint {
  font-size: .83rem;
  color: #8a7a6a;
  line-height: 1.65;
  margin: 0 0 16px 0;
}

/* ── Buttons ── */
.lbl-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 22px;
  border-radius: 8px;
  font-size: .88rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all .22s;
  letter-spacing: .3px;
  position: relative;
  overflow: hidden;
}
.lbl-btn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,.08) 0%, transparent 50%);
  pointer-events: none;
}
.lbl-btn--primary {
  background: linear-gradient(135deg, #5D3A3A 0%, #3D1818 100%);
  color: #F7E9D2;
  box-shadow: 0 2px 10px rgba(61, 24, 24, .22), inset 0 1px 0 rgba(255,255,255,.06);
}
.lbl-btn--primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #7B4A4A 0%, #4D2828 100%);
  box-shadow: 0 4px 18px rgba(61, 24, 24, .30);
  transform: translateY(-1px);
}
.lbl-btn--accent {
  background: linear-gradient(135deg, #D4A574 0%, #B8893E 100%);
  color: #fff;
  box-shadow: 0 2px 10px rgba(184, 137, 62, .28), inset 0 1px 0 rgba(255,255,255,.12);
}
.lbl-btn--accent:hover:not(:disabled) {
  box-shadow: 0 4px 18px rgba(184, 137, 62, .38);
  transform: translateY(-1px);
}
.lbl-btn--ghost {
  background: transparent;
  color: #5D3A3A;
  border: 1px solid #d5c9ba;
}
.lbl-btn--ghost:hover:not(:disabled) { background: rgba(212, 165, 116, .08); border-color: #D4A574; }
.lbl-btn:disabled { opacity: .45; cursor: not-allowed; }
.lbl-btn--sm { padding: 7px 14px; font-size: .78rem; }

/* ── Field label with ornament ── */
.lbl-field-label {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: .72rem;
  font-weight: 700;
  color: #7a6050;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 16px 0 7px;
}
.lbl-field-label::before {
  content: '';
  display: inline-block;
  width: 12px;
  height: 1px;
  background: linear-gradient(90deg, #D4A574, #c8963a);
  flex-shrink: 0;
}

/* ── Range slider ── */
.lbl-range {
  width: 100%;
  accent-color: #7B2323;
  cursor: pointer;
  height: 6px;
}

/* ── Select ── */
.lbl-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d5c9ba;
  border-radius: 7px;
  font-size: .87rem;
  background: #fff;
  color: #3D1818;
  cursor: pointer;
  box-shadow: inset 0 1px 2px rgba(0,0,0,.04);
}
.lbl-select:focus { outline: none; border-color: #D4A574; }

/* ── Shape cards ── */
.lbl-shape-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.lbl-shape-dims {
  margin-top: 16px;
  padding: 14px;
  background: linear-gradient(180deg, #fdf9f4 0%, #f8f3eb 100%);
  border-radius: 10px;
  border: 1px solid #e2d8c8;
  box-shadow: inset 0 1px 3px rgba(61,24,24,.04);
}
.lbl-dim-label {
  display: block;
  font-size: .75rem;
  color: #7a6050;
  margin: 8px 0 4px;
  font-weight: 600;
  letter-spacing: .3px;
}
.lbl-shape-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  padding: 12px 6px;
  border: 1.5px solid #e2d8c8;
  border-radius: 12px;
  background: linear-gradient(180deg, #fff 0%, #faf6ef 100%);
  cursor: pointer;
  transition: all .22s;
  box-shadow: 0 1px 4px rgba(61,24,24,.04);
}
.lbl-shape-card:hover {
  border-color: #D4A574;
  background: #fff;
  box-shadow: 0 3px 12px rgba(212,165,116,.18);
  transform: translateY(-1px);
}
.lbl-shape-card.active {
  border-color: #7B2323;
  background: linear-gradient(180deg, #fff 0%, #fdf5f0 100%);
  box-shadow: 0 3px 14px rgba(123,35,35,.15), inset 0 0 0 1px rgba(123,35,35,.06);
}
.lbl-shape-card span {
  font-size: .72rem;
  font-weight: 600;
  color: #5D3A3A;
  letter-spacing: .3px;
}
.lbl-shape-thumb { width: 54px; height: auto; display: block; }

/* ── Color swatches ── */
.lbl-color-custom-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
.lbl-color-native {
  width: 40px;
  height: 40px;
  border: 2px solid #d5c9ba;
  border-radius: 8px;
  cursor: pointer;
  padding: 2px;
  background: none;
  flex-shrink: 0;
  box-shadow: 0 1px 4px rgba(61,24,24,.1);
  transition: border-color .2s, box-shadow .2s;
}
.lbl-color-native:hover { border-color: #D4A574; box-shadow: 0 2px 8px rgba(212,165,116,.3); }
.lbl-color-native::-webkit-color-swatch-wrapper { padding: 0; border-radius: 4px; }
.lbl-color-native::-webkit-color-swatch { border: none; border-radius: 4px; }
/* Legacy preview box (still used in logo hex input) */
.lbl-color-preview-box {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 2px solid #d5c9ba;
  flex-shrink: 0;
  transition: background-color .2s;
}
.lbl-color-preview-sm { width: 32px; height: 32px; }
.lbl-hex-wrap {
  display: flex;
  align-items: center;
  gap: 2px;
  border: 1.5px solid #d5c9ba;
  border-radius: 7px;
  padding: 0 8px;
  background: #fff;
  flex: 1;
  box-shadow: inset 0 1px 2px rgba(0,0,0,.03);
  transition: border-color .2s;
}
.lbl-hex-wrap:focus-within { border-color: #D4A574; box-shadow: 0 0 0 2px rgba(212,165,116,.15); }
.lbl-color-hash {
  font-family: monospace;
  font-size: .92rem;
  color: #9a8070;
  font-weight: 600;
}
.lbl-hex-input {
  flex: 1;
  font-family: monospace;
  font-size: .9rem;
  padding: 8px 4px;
  border: none;
  outline: none;
  color: #3D1818;
  background: transparent;
  min-width: 0;
  text-transform: uppercase;
}
.lbl-swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.lbl-swatch {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all .2s;
  box-shadow: 0 1px 4px rgba(0,0,0,.12), inset 0 0 0 1px rgba(0,0,0,.08);
}
.lbl-swatch:hover { transform: scale(1.15); box-shadow: 0 3px 10px rgba(0,0,0,.2); }
.lbl-swatch.active {
  border-color: #D4A574;
  box-shadow: 0 0 0 3px rgba(212,165,116,.4), 0 2px 8px rgba(0,0,0,.15);
  transform: scale(1.1);
}
.lbl-swatch--checker {
  background-image:
    linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%);
  background-size: 8px 8px;
  background-position: 0 0, 0 4px, 4px -4px, -4px 0px;
  background-color: #fff;
}

/* ── Cartoon styles ── */
.lbl-cartoon-section {
  margin-top: 16px;
  border: 1px solid #e2d8c8;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(61,24,24,.05);
}
.lbl-cartoon-toggle {
  padding: 10px 14px;
  font-size: .85rem;
  font-weight: 500;
  color: #5D3A3A;
  cursor: pointer;
  background: linear-gradient(180deg, #fdf9f4 0%, #f8f3eb 100%);
  display: flex;
  align-items: center;
  gap: 8px;
}
.lbl-cartoon-toggle:hover { background: linear-gradient(180deg, #f8f3eb 0%, #f2ece0 100%); }
.lbl-cartoon-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
  padding: 10px 12px;
  background: #fdfaf5;
}
.lbl-cartoon-btn {
  padding: 8px 6px;
  border: 1px solid #d5c9ba;
  border-radius: 7px;
  background: #fff;
  color: #3D1818;
  font-size: .78rem;
  font-weight: 500;
  cursor: pointer;
  transition: all .2s;
}
.lbl-cartoon-btn:hover:not(:disabled) { border-color: #D4A574; background: #fdf9f4; }
.lbl-cartoon-btn.active {
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  color: #F7E9D2;
  border-color: transparent;
  box-shadow: 0 2px 8px rgba(61,24,24,.2);
}
.lbl-cartoon-btn:disabled { opacity: .4; cursor: not-allowed; }
.lbl-processing { display: flex; align-items: center; gap: 8px; padding: 8px 12px; font-size: .82rem; color: #8a7a6a; }
.lbl-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #d5c9ba;
  border-top-color: #7B2323;
  border-radius: 50%;
  animation: lblSpin .6s linear infinite;
}
@keyframes lblSpin { to { transform: rotate(360deg); } }

/* ── Photo section ── */
.lbl-photo-toggle { margin-bottom: 4px; }
.lbl-frame-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 6px;
  margin-bottom: 10px;
}
.lbl-frame-btn {
  padding: 8px 4px;
  border: 1.5px solid #e2d8c8;
  border-radius: 8px;
  background: linear-gradient(180deg, #fdfaf5 0%, #f8f4ec 100%);
  color: #3D1818;
  font-size: .75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all .22s;
  text-align: center;
}
.lbl-frame-btn:hover { border-color: #D4A574; background: #fff; }
.lbl-frame-btn.active {
  border-color: #7B2323;
  background: linear-gradient(180deg, #fff 0%, #fdf5f0 100%);
  box-shadow: 0 2px 8px rgba(123,35,35,.12);
}
.lbl-frame-dims { margin-bottom: 8px; }
.lbl-photo-privacy {
  font-size: .75rem;
  color: #7a6050;
  font-style: italic;
  margin-top: 16px;
  padding: 10px 14px;
  background: linear-gradient(135deg, rgba(212,165,116,.08) 0%, rgba(212,165,116,.04) 100%);
  border-radius: 8px;
  border-left: 3px solid #D4A574;
  line-height: 1.6;
  box-shadow: 0 1px 4px rgba(61,24,24,.04);
}

/* ── Toggle rows ── */
.lbl-toggle-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: .9rem;
  color: #3D1818;
  cursor: pointer;
  margin-bottom: 12px;
}
.lbl-toggle-row input[type="checkbox"] {
  width: 17px;
  height: 17px;
  accent-color: #7B2323;
}

/* ── Decoration categories ── */
.lbl-deco-cats {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.lbl-deco-cat-tab {
  padding: 5px 11px;
  border: 1px solid #e2d8c8;
  border-radius: 16px;
  font-size: .73rem;
  font-weight: 600;
  color: #6D4A2A;
  background: linear-gradient(180deg, #fdfaf5 0%, #f8f3eb 100%);
  cursor: pointer;
  transition: all .2s;
  white-space: nowrap;
  letter-spacing: .2px;
}
.lbl-deco-cat-tab:hover { border-color: #D4A574; }
.lbl-deco-cat-tab.active {
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  color: #F7E9D2;
  border-color: transparent;
  box-shadow: 0 2px 6px rgba(61,24,24,.2);
}
.lbl-deco-upload {
  margin-bottom: 12px;
}

/* ── Decoration catalog ── */
.lbl-deco-catalog {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}
.lbl-deco-cat-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 4px 8px;
  border: 1px solid #e2d8c8;
  border-radius: 9px;
  background: linear-gradient(180deg, #fdfaf5 0%, #f8f3eb 100%);
  cursor: pointer;
  transition: all .22s;
}
.lbl-deco-cat-btn:hover {
  border-color: #D4A574;
  background: #fff;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(212,165,116,.18);
}
.lbl-deco-cat-img { width: 30px; height: 30px; object-fit: contain; }
.lbl-deco-cat-btn span { font-size: .63rem; color: #8a7a6a; }

.lbl-deco-placed { margin-bottom: 12px; }
.lbl-deco-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #e2d8c8;
  border-radius: 7px;
  margin-top: 4px;
  cursor: pointer;
  font-size: .82rem;
  transition: all .15s;
  background: #fdfaf5;
}
.lbl-deco-item:hover { background: #f8f3eb; }
.lbl-deco-item.active { border-color: #D4A574; background: rgba(212, 165, 116, .1); }
.lbl-deco-item-name { color: #3D1818; font-weight: 500; }
.lbl-deco-remove {
  border: none;
  background: none;
  color: #c0392b;
  font-size: 1.1rem;
  cursor: pointer;
  padding: 0 4px;
  opacity: .45;
  transition: opacity .2s;
}
.lbl-deco-remove:hover { opacity: 1; }
.lbl-deco-props { padding-top: 4px; }

/* ── Text items ── */
.lbl-text-item {
  border: 1px solid #e2d8c8;
  border-radius: 10px;
  padding: 10px 12px;
  margin-top: 10px;
  cursor: pointer;
  transition: all .15s;
  background: linear-gradient(180deg, #fdfaf5 0%, #f8f4ec 100%);
}
.lbl-text-item:hover { background: #faf6ef; }
.lbl-text-item.active {
  border-color: #D4A574;
  background: rgba(212, 165, 116, .07);
  box-shadow: 0 2px 10px rgba(212,165,116,.15);
}
.lbl-text-item-head { display: flex; align-items: center; gap: 8px; }
.lbl-text-input {
  flex: 1;
  border: 1px solid #e0d8cc;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: .88rem;
  color: #3D1818;
  background: #fff;
  transition: border-color .2s;
}
.lbl-text-input:focus { outline: none; border-color: #D4A574; box-shadow: 0 0 0 2px rgba(212,165,116,.12); }
.lbl-text-props { padding-top: 10px; }
.lbl-text-row { display: flex; align-items: center; gap: 10px; }
.lbl-text-toggles { display: flex; gap: 6px; margin-top: 10px; }
.lbl-toggle-btn {
  width: 32px;
  height: 32px;
  border: 1px solid #d5c9ba;
  border-radius: 6px;
  background: #fff;
  font-size: .88rem;
  font-weight: 700;
  color: #5D3A3A;
  cursor: pointer;
  transition: all .2s;
}
.lbl-toggle-btn:hover { border-color: #D4A574; }
.lbl-toggle-btn.on {
  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);
  color: #F7E9D2;
  border-color: transparent;
  box-shadow: 0 2px 6px rgba(61,24,24,.2);
}

/* ── Navigation ── */
.lbl-nav {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: auto;
  padding-top: 18px;
  border-top: 1px solid #e2d8c8;
  position: relative;
}
.lbl-nav::before {
  content: '◆';
  position: absolute;
  top: -7px;
  left: 50%;
  transform: translateX(-50%);
  color: #D4A574;
  font-size: .55rem;
  background: linear-gradient(180deg, #fefcf8, #faf6ef);
  padding: 0 6px;
}
.lbl-nav-spacer { flex: 1; }

/* ── Active decoration highlight ── */
.lbl-deco-active { filter: drop-shadow(0 0 4px rgba(212, 165, 116, .85)); }

/* ── Responsive ── */
@media (max-width: 1024px) {
  .lbl-main {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    height: auto;
  }
  .lbl-preview-area { padding: 24px; height: auto; }
  .lbl-preview-card { max-width: 380px; }
  .lbl-controls {
    border-left: none;
    border-top: 1px solid #e2d8c8;
    height: auto;
    padding: 22px 24px;
  }
  .lbl-steps { padding: 14px 12px; gap: 0; overflow-x: auto; justify-content: flex-start; }
  .lbl-step-line { width: 18px; }
  .lbl-step-pill { padding: 5px 10px; }
  .lbl-step-label { font-size: .7rem; }
  .lbl-shape-grid { grid-template-columns: repeat(3, 1fr); gap: 8px; }
  .lbl-brand-title { font-size: 1.05rem; letter-spacing: 2px; }
}

@media (max-width: 560px) {
  .lbl-preview-area { padding: 16px; }
  .lbl-controls { padding: 16px 14px; }
  .lbl-shape-grid { grid-template-columns: 1fr 1fr; gap: 8px; }
  .lbl-deco-catalog { grid-template-columns: repeat(4, 1fr); gap: 6px; }
  .lbl-cartoon-grid { grid-template-columns: 1fr 1fr; }
  .lbl-step-label { display: none; }
  .lbl-step-pill { padding: 5px 8px; }
  .lbl-step-line { width: 10px; }
  .lbl-brand-orn { display: none; }
  .lbl-brand-title { font-size: .95rem; letter-spacing: 2px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/LabelsPage.css"],"names":[],"mappings":"AAAA;;kDAEkD;;AAIlD,qBAAqB;AACrB;EACE,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8EAA8E;EAC9E,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;;;KAOG;EACH,oBAAoB;AACtB;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,SAAS;EACT,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;EACN,uBAAuB;EACvB,6DAA6D;EAC7D,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,WAAW;EACX,sFAAsF;EACtF,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;AACA,sBAAsB,oDAAoD,EAAE;;AAE5E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA,uBAAuB,mCAAmC,EAAE;AAC5D;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,iFAAiF;AACnF;AACA,sBAAsB,qCAAqC,EAAE;;AAE7D;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,6DAA6D;EAC7D,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,6DAA6D;EAC7D,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;AACtB;AACA,wCAAwC,cAAc,EAAE;AACxD,sCAAsC,cAAc,EAAE;;AAEtD,4CAA4C;AAC5C;EACE,aAAa;EACb,gCAAgC;EAChC,OAAO;EACP,aAAa;EACb,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb;;;WAGS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;;;;;;;;;;KAcG;EACH,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iGAAiG;AACnG;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;EAC7C,YAAY;EACZ,sBAAsB;AACxB;AACA,mCAAmC,UAAU,EAAE;AAC/C,yCAAyC,mBAAmB,EAAE;AAC9D,yCAAyC,6CAA6C,EAAE,kBAAkB,EAAE;;AAE5G;EACE,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qEAAqE;AACvE;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,oBAAoB;AACtB;AACA;EACE,6DAA6D;EAC7D,cAAc;EACd,iFAAiF;AACnF;AACA;EACE,6DAA6D;EAC7D,4CAA4C;EAC5C,2BAA2B;AAC7B;AACA;EACE,6DAA6D;EAC7D,WAAW;EACX,mFAAmF;AACrF;AACA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;AAC3B;AACA,uCAAuC,oCAAoC,EAAE,qBAAqB,EAAE;AACpG,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;AACvD,eAAe,iBAAiB,EAAE,iBAAiB,EAAE;;AAErD,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,2CAA2C;AAC7C;AACA,oBAAoB,aAAa,EAAE,qBAAqB,EAAE;;AAE1D,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,0DAA0D;EAC1D,eAAe;EACf,oBAAoB;EACpB,wCAAwC;AAC1C;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;EAC5C,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,0DAA0D;EAC1D,+EAA+E;AACjF;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;AACA,mBAAmB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;;AAE9D,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,4CAA4C;AAC9C;AACA,0BAA0B,qBAAqB,EAAE,0CAA0C,EAAE;AAC7F,kDAAkD,UAAU,EAAE,kBAAkB,EAAE;AAClF,0CAA0C,YAAY,EAAE,kBAAkB,EAAE;AAC5E,sDAAsD;AACtD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,gCAAgC;AAClC;AACA,wBAAwB,WAAW,EAAE,YAAY,EAAE;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,2CAA2C;EAC3C,4BAA4B;AAC9B;AACA,6BAA6B,qBAAqB,EAAE,2CAA2C,EAAE;AACjG;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,sEAAsE;AACxE;AACA,oBAAoB,sBAAsB,EAAE,qCAAqC,EAAE;AACnF;EACE,qBAAqB;EACrB,qEAAqE;EACrE,qBAAqB;AACvB;AACA;EACE;;;;sDAIoD;EACpD,wBAAwB;EACxB,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA,4BAA4B,6DAA6D,EAAE;AAC3F;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,wCAAwC,qBAAqB,EAAE,mBAAmB,EAAE;AACpF;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,uCAAuC;AACzC;AACA,4BAA4B,WAAW,EAAE,mBAAmB,EAAE;AAC9D,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACtH;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;AACA,qBAAqB,KAAK,yBAAyB,EAAE,EAAE;;AAEvD,wBAAwB;AACxB,oBAAoB,kBAAkB,EAAE;AACxC;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;AACA,uBAAuB,qBAAqB,EAAE,gBAAgB,EAAE;AAChE;EACE,qBAAqB;EACrB,0DAA0D;EAC1D,yCAAyC;AAC3C;AACA,kBAAkB,kBAAkB,EAAE;AACtC;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yFAAyF;EACzF,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;AACA,0BAA0B,qBAAqB,EAAE;AACjD;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA,oBAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE;AACpE,yBAAyB,iBAAiB,EAAE,cAAc,EAAE;;AAE5D,mBAAmB,mBAAmB,EAAE;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;AACA,uBAAuB,mBAAmB,EAAE;AAC5C,wBAAwB,qBAAqB,EAAE,mCAAmC,EAAE;AACpF,sBAAsB,cAAc,EAAE,gBAAgB,EAAE;AACxD;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,uBAAuB;AACzB;AACA,yBAAyB,UAAU,EAAE;AACrC,kBAAkB,gBAAgB,EAAE;;AAEpC,qBAAqB;AACrB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6DAA6D;AAC/D;AACA,uBAAuB,mBAAmB,EAAE;AAC5C;EACE,qBAAqB;EACrB,oCAAoC;EACpC,4CAA4C;AAC9C;AACA,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACpE;EACE,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,wBAAwB,aAAa,EAAE,qBAAqB,EAAE,2CAA2C,EAAE;AAC3G,kBAAkB,iBAAiB,EAAE;AACrC,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC/D,oBAAoB,aAAa,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA,wBAAwB,qBAAqB,EAAE;AAC/C;EACE,6DAA6D;EAC7D,cAAc;EACd,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,iBAAiB;EACjB,qDAAqD;EACrD,cAAc;AAChB;AACA,kBAAkB,OAAO,EAAE;;AAE3B,sCAAsC;AACtC,mBAAmB,qDAAqD,EAAE;;AAE1E,qBAAqB;AACrB;EACE;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;EACd;EACA,oBAAoB,aAAa,EAAE,YAAY,EAAE;EACjD,oBAAoB,gBAAgB,EAAE;EACtC;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;EACpB;EACA,aAAa,kBAAkB,EAAE,MAAM,EAAE,gBAAgB,EAAE,2BAA2B,EAAE;EACxF,iBAAiB,WAAW,EAAE;EAC9B,iBAAiB,iBAAiB,EAAE;EACpC,kBAAkB,gBAAgB,EAAE;EACpC,kBAAkB,qCAAqC,EAAE,QAAQ,EAAE;EACnE,mBAAmB,kBAAkB,EAAE,mBAAmB,EAAE;AAC9D;;AAEA;EACE,oBAAoB,aAAa,EAAE;EACnC,gBAAgB,kBAAkB,EAAE;EACpC,kBAAkB,8BAA8B,EAAE,QAAQ,EAAE;EAC5D,oBAAoB,qCAAqC,EAAE,QAAQ,EAAE;EACrE,oBAAoB,8BAA8B,EAAE;EACpD,kBAAkB,aAAa,EAAE;EACjC,iBAAiB,gBAAgB,EAAE;EACnC,iBAAiB,WAAW,EAAE;EAC9B,iBAAiB,aAAa,EAAE;EAChC,mBAAmB,iBAAiB,EAAE,mBAAmB,EAAE;AAC7D","sourcesContent":["/* =============================================\n   Label Creator — Premium step wizard\n   ============================================= */\n\n@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;1,400&display=swap');\n\n/* ── Page shell ── */\n.lbl-page {\n  min-height: 100vh;\n  width: 100%;\n  box-sizing: border-box;\n  background: #f6f2ea;\n  color: #3D1818;\n  display: flex;\n  flex-direction: column;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  overflow-x: hidden;\n}\n\n/* ── Brand bar ── */\n.lbl-brand-bar {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  padding: 16px 32px;\n  background: linear-gradient(135deg, #1a0808 0%, #3D1818 45%, #2a1010 100%);\n  border-bottom: 2px solid #c8963a;\n  position: relative;\n  overflow: hidden;\n}\n.lbl-brand-bar::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background:\n    repeating-linear-gradient(\n      90deg,\n      transparent 0,\n      transparent 40px,\n      rgba(212, 165, 116, .04) 40px,\n      rgba(212, 165, 116, .04) 41px\n    );\n  pointer-events: none;\n}\n.lbl-brand-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.25rem;\n  font-weight: 400;\n  letter-spacing: 4px;\n  text-transform: uppercase;\n  color: #F7E9D2;\n  margin: 0;\n  line-height: 1;\n}\n.lbl-brand-orn {\n  color: #D4A574;\n  font-size: 1.6rem;\n  line-height: 1;\n  opacity: .9;\n  flex-shrink: 0;\n}\n\n/* ── Step indicator ── */\n.lbl-steps {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n  padding: 18px 24px 14px;\n  background: linear-gradient(180deg, #fdf9f3 0%, #f9f5ee 100%);\n  border-bottom: 1px solid #e2d8c8;\n  box-shadow: 0 2px 8px rgba(61, 24, 24, .06);\n  position: relative;\n}\n.lbl-steps::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 5%;\n  right: 5%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, #D4A574 30%, #D4A574 70%, transparent);\n  opacity: .4;\n}\n.lbl-step-line {\n  width: 32px;\n  height: 1px;\n  background: #ddd5c8;\n  flex-shrink: 0;\n  transition: background .3s;\n}\n.lbl-step-line.done { background: linear-gradient(90deg, #D4A574, #c8963a); }\n\n.lbl-step-pill {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 6px 12px;\n  border-radius: 24px;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  transition: all .25s;\n  white-space: nowrap;\n}\n.lbl-step-pill:hover { background: rgba(212, 165, 116, .1); }\n.lbl-step-pill.active {\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  border-color: transparent;\n  box-shadow: 0 2px 12px rgba(61, 24, 24, .22), inset 0 1px 0 rgba(255,255,255,.06);\n}\n.lbl-step-pill.done { border-color: rgba(212, 165, 116, .5); }\n\n.lbl-step-num {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: .72rem;\n  font-weight: 700;\n  background: #e8e0d4;\n  color: #5D3A3A;\n  transition: all .25s;\n  flex-shrink: 0;\n}\n.lbl-step-pill.active .lbl-step-num {\n  background: linear-gradient(135deg, #D4A574 0%, #b8893e 100%);\n  color: #fff;\n  box-shadow: 0 1px 4px rgba(184, 137, 62, .4);\n}\n.lbl-step-pill.done .lbl-step-num {\n  background: linear-gradient(135deg, #D4A574 0%, #b8893e 100%);\n  color: #fff;\n}\n.lbl-step-label {\n  font-size: .76rem;\n  font-weight: 500;\n  color: #9a8a7a;\n  transition: color .25s;\n  letter-spacing: .2px;\n}\n.lbl-step-pill.active .lbl-step-label { color: #F7E9D2; }\n.lbl-step-pill.done .lbl-step-label { color: #6D4A2A; }\n\n/* ── Main layout — fills full viewport ── */\n.lbl-main {\n  display: grid;\n  grid-template-columns: 1fr 460px;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  min-width: 0;\n  height: calc(100vh - 70px - 60px - 58px);\n}\n\n/* ── Preview area (light elegant) ── */\n.lbl-preview-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 28px;\n  min-height: 0;\n  background:\n    radial-gradient(ellipse at 50% 40%, rgba(212, 165, 116, .14) 0%, transparent 65%),\n    radial-gradient(ellipse at 80% 80%, rgba(123, 35, 35, .04) 0%, transparent 50%),\n    #f3ede0;\n  position: relative;\n  overflow: hidden;\n}\n.lbl-preview-area::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    repeating-linear-gradient(\n      0deg,\n      transparent 0,\n      transparent 39px,\n      rgba(180, 140, 80, .06) 39px,\n      rgba(180, 140, 80, .06) 40px\n    ),\n    repeating-linear-gradient(\n      90deg,\n      transparent 0,\n      transparent 39px,\n      rgba(180, 140, 80, .06) 39px,\n      rgba(180, 140, 80, .06) 40px\n    );\n  pointer-events: none;\n}\n\n.lbl-preview-card {\n  background: transparent;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 360px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  filter: drop-shadow(0 6px 28px rgba(61, 24, 24, .18)) drop-shadow(0 2px 6px rgba(61, 24, 24, .1));\n}\n\n.lbl-svg {\n  width: 100%;\n  height: 100%;\n  display: block;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: auto;\n}\n\n/* ── Controls panel ── */\n.lbl-controls {\n  background: linear-gradient(180deg, #fefcf8 0%, #faf6ef 100%);\n  border-left: 1px solid #e2d8c8;\n  padding: 24px 36px 20px;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  height: 100%;\n  box-shadow: -2px 0 12px rgba(61, 24, 24, .04);\n  min-width: 0;\n  box-sizing: border-box;\n}\n.lbl-controls::-webkit-scrollbar { width: 5px; }\n.lbl-controls::-webkit-scrollbar-track { background: #f0ebe0; }\n.lbl-controls::-webkit-scrollbar-thumb { background: linear-gradient(#D4A574, #b8893e); border-radius: 3px; }\n\n.lbl-ctrl-title {\n  font-family: 'Playfair Display', serif;\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #3D1818;\n  margin: 0 0 4px 0;\n  padding-bottom: 12px;\n  position: relative;\n  letter-spacing: .5px;\n}\n.lbl-ctrl-title::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background: linear-gradient(90deg, #c8963a, #D4A574 50%, transparent);\n}\n\n/* ── Panel ── */\n.lbl-panel {\n  flex: 1;\n  padding-top: 14px;\n}\n.lbl-panel-hint {\n  font-size: .83rem;\n  color: #8a7a6a;\n  line-height: 1.65;\n  margin: 0 0 16px 0;\n}\n\n/* ── Buttons ── */\n.lbl-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 22px;\n  border-radius: 8px;\n  font-size: .88rem;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all .22s;\n  letter-spacing: .3px;\n  position: relative;\n  overflow: hidden;\n}\n.lbl-btn::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(255,255,255,.08) 0%, transparent 50%);\n  pointer-events: none;\n}\n.lbl-btn--primary {\n  background: linear-gradient(135deg, #5D3A3A 0%, #3D1818 100%);\n  color: #F7E9D2;\n  box-shadow: 0 2px 10px rgba(61, 24, 24, .22), inset 0 1px 0 rgba(255,255,255,.06);\n}\n.lbl-btn--primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, #7B4A4A 0%, #4D2828 100%);\n  box-shadow: 0 4px 18px rgba(61, 24, 24, .30);\n  transform: translateY(-1px);\n}\n.lbl-btn--accent {\n  background: linear-gradient(135deg, #D4A574 0%, #B8893E 100%);\n  color: #fff;\n  box-shadow: 0 2px 10px rgba(184, 137, 62, .28), inset 0 1px 0 rgba(255,255,255,.12);\n}\n.lbl-btn--accent:hover:not(:disabled) {\n  box-shadow: 0 4px 18px rgba(184, 137, 62, .38);\n  transform: translateY(-1px);\n}\n.lbl-btn--ghost {\n  background: transparent;\n  color: #5D3A3A;\n  border: 1px solid #d5c9ba;\n}\n.lbl-btn--ghost:hover:not(:disabled) { background: rgba(212, 165, 116, .08); border-color: #D4A574; }\n.lbl-btn:disabled { opacity: .45; cursor: not-allowed; }\n.lbl-btn--sm { padding: 7px 14px; font-size: .78rem; }\n\n/* ── Field label with ornament ── */\n.lbl-field-label {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: .72rem;\n  font-weight: 700;\n  color: #7a6050;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin: 16px 0 7px;\n}\n.lbl-field-label::before {\n  content: '';\n  display: inline-block;\n  width: 12px;\n  height: 1px;\n  background: linear-gradient(90deg, #D4A574, #c8963a);\n  flex-shrink: 0;\n}\n\n/* ── Range slider ── */\n.lbl-range {\n  width: 100%;\n  accent-color: #7B2323;\n  cursor: pointer;\n  height: 6px;\n}\n\n/* ── Select ── */\n.lbl-select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #d5c9ba;\n  border-radius: 7px;\n  font-size: .87rem;\n  background: #fff;\n  color: #3D1818;\n  cursor: pointer;\n  box-shadow: inset 0 1px 2px rgba(0,0,0,.04);\n}\n.lbl-select:focus { outline: none; border-color: #D4A574; }\n\n/* ── Shape cards ── */\n.lbl-shape-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n.lbl-shape-dims {\n  margin-top: 16px;\n  padding: 14px;\n  background: linear-gradient(180deg, #fdf9f4 0%, #f8f3eb 100%);\n  border-radius: 10px;\n  border: 1px solid #e2d8c8;\n  box-shadow: inset 0 1px 3px rgba(61,24,24,.04);\n}\n.lbl-dim-label {\n  display: block;\n  font-size: .75rem;\n  color: #7a6050;\n  margin: 8px 0 4px;\n  font-weight: 600;\n  letter-spacing: .3px;\n}\n.lbl-shape-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 7px;\n  padding: 12px 6px;\n  border: 1.5px solid #e2d8c8;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #fff 0%, #faf6ef 100%);\n  cursor: pointer;\n  transition: all .22s;\n  box-shadow: 0 1px 4px rgba(61,24,24,.04);\n}\n.lbl-shape-card:hover {\n  border-color: #D4A574;\n  background: #fff;\n  box-shadow: 0 3px 12px rgba(212,165,116,.18);\n  transform: translateY(-1px);\n}\n.lbl-shape-card.active {\n  border-color: #7B2323;\n  background: linear-gradient(180deg, #fff 0%, #fdf5f0 100%);\n  box-shadow: 0 3px 14px rgba(123,35,35,.15), inset 0 0 0 1px rgba(123,35,35,.06);\n}\n.lbl-shape-card span {\n  font-size: .72rem;\n  font-weight: 600;\n  color: #5D3A3A;\n  letter-spacing: .3px;\n}\n.lbl-shape-thumb { width: 54px; height: auto; display: block; }\n\n/* ── Color swatches ── */\n.lbl-color-custom-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 10px;\n}\n.lbl-color-native {\n  width: 40px;\n  height: 40px;\n  border: 2px solid #d5c9ba;\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 2px;\n  background: none;\n  flex-shrink: 0;\n  box-shadow: 0 1px 4px rgba(61,24,24,.1);\n  transition: border-color .2s, box-shadow .2s;\n}\n.lbl-color-native:hover { border-color: #D4A574; box-shadow: 0 2px 8px rgba(212,165,116,.3); }\n.lbl-color-native::-webkit-color-swatch-wrapper { padding: 0; border-radius: 4px; }\n.lbl-color-native::-webkit-color-swatch { border: none; border-radius: 4px; }\n/* Legacy preview box (still used in logo hex input) */\n.lbl-color-preview-box {\n  width: 44px;\n  height: 44px;\n  border-radius: 8px;\n  border: 2px solid #d5c9ba;\n  flex-shrink: 0;\n  transition: background-color .2s;\n}\n.lbl-color-preview-sm { width: 32px; height: 32px; }\n.lbl-hex-wrap {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  border: 1.5px solid #d5c9ba;\n  border-radius: 7px;\n  padding: 0 8px;\n  background: #fff;\n  flex: 1;\n  box-shadow: inset 0 1px 2px rgba(0,0,0,.03);\n  transition: border-color .2s;\n}\n.lbl-hex-wrap:focus-within { border-color: #D4A574; box-shadow: 0 0 0 2px rgba(212,165,116,.15); }\n.lbl-color-hash {\n  font-family: monospace;\n  font-size: .92rem;\n  color: #9a8070;\n  font-weight: 600;\n}\n.lbl-hex-input {\n  flex: 1;\n  font-family: monospace;\n  font-size: .9rem;\n  padding: 8px 4px;\n  border: none;\n  outline: none;\n  color: #3D1818;\n  background: transparent;\n  min-width: 0;\n  text-transform: uppercase;\n}\n.lbl-swatches {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.lbl-swatch {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: all .2s;\n  box-shadow: 0 1px 4px rgba(0,0,0,.12), inset 0 0 0 1px rgba(0,0,0,.08);\n}\n.lbl-swatch:hover { transform: scale(1.15); box-shadow: 0 3px 10px rgba(0,0,0,.2); }\n.lbl-swatch.active {\n  border-color: #D4A574;\n  box-shadow: 0 0 0 3px rgba(212,165,116,.4), 0 2px 8px rgba(0,0,0,.15);\n  transform: scale(1.1);\n}\n.lbl-swatch--checker {\n  background-image:\n    linear-gradient(45deg, #ccc 25%, transparent 25%),\n    linear-gradient(-45deg, #ccc 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, #ccc 75%),\n    linear-gradient(-45deg, transparent 75%, #ccc 75%);\n  background-size: 8px 8px;\n  background-position: 0 0, 0 4px, 4px -4px, -4px 0px;\n  background-color: #fff;\n}\n\n/* ── Cartoon styles ── */\n.lbl-cartoon-section {\n  margin-top: 16px;\n  border: 1px solid #e2d8c8;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 1px 4px rgba(61,24,24,.05);\n}\n.lbl-cartoon-toggle {\n  padding: 10px 14px;\n  font-size: .85rem;\n  font-weight: 500;\n  color: #5D3A3A;\n  cursor: pointer;\n  background: linear-gradient(180deg, #fdf9f4 0%, #f8f3eb 100%);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.lbl-cartoon-toggle:hover { background: linear-gradient(180deg, #f8f3eb 0%, #f2ece0 100%); }\n.lbl-cartoon-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 6px;\n  padding: 10px 12px;\n  background: #fdfaf5;\n}\n.lbl-cartoon-btn {\n  padding: 8px 6px;\n  border: 1px solid #d5c9ba;\n  border-radius: 7px;\n  background: #fff;\n  color: #3D1818;\n  font-size: .78rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all .2s;\n}\n.lbl-cartoon-btn:hover:not(:disabled) { border-color: #D4A574; background: #fdf9f4; }\n.lbl-cartoon-btn.active {\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  color: #F7E9D2;\n  border-color: transparent;\n  box-shadow: 0 2px 8px rgba(61,24,24,.2);\n}\n.lbl-cartoon-btn:disabled { opacity: .4; cursor: not-allowed; }\n.lbl-processing { display: flex; align-items: center; gap: 8px; padding: 8px 12px; font-size: .82rem; color: #8a7a6a; }\n.lbl-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #d5c9ba;\n  border-top-color: #7B2323;\n  border-radius: 50%;\n  animation: lblSpin .6s linear infinite;\n}\n@keyframes lblSpin { to { transform: rotate(360deg); } }\n\n/* ── Photo section ── */\n.lbl-photo-toggle { margin-bottom: 4px; }\n.lbl-frame-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 6px;\n  margin-bottom: 10px;\n}\n.lbl-frame-btn {\n  padding: 8px 4px;\n  border: 1.5px solid #e2d8c8;\n  border-radius: 8px;\n  background: linear-gradient(180deg, #fdfaf5 0%, #f8f4ec 100%);\n  color: #3D1818;\n  font-size: .75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all .22s;\n  text-align: center;\n}\n.lbl-frame-btn:hover { border-color: #D4A574; background: #fff; }\n.lbl-frame-btn.active {\n  border-color: #7B2323;\n  background: linear-gradient(180deg, #fff 0%, #fdf5f0 100%);\n  box-shadow: 0 2px 8px rgba(123,35,35,.12);\n}\n.lbl-frame-dims { margin-bottom: 8px; }\n.lbl-photo-privacy {\n  font-size: .75rem;\n  color: #7a6050;\n  font-style: italic;\n  margin-top: 16px;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, rgba(212,165,116,.08) 0%, rgba(212,165,116,.04) 100%);\n  border-radius: 8px;\n  border-left: 3px solid #D4A574;\n  line-height: 1.6;\n  box-shadow: 0 1px 4px rgba(61,24,24,.04);\n}\n\n/* ── Toggle rows ── */\n.lbl-toggle-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: .9rem;\n  color: #3D1818;\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n.lbl-toggle-row input[type=\"checkbox\"] {\n  width: 17px;\n  height: 17px;\n  accent-color: #7B2323;\n}\n\n/* ── Decoration categories ── */\n.lbl-deco-cats {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n.lbl-deco-cat-tab {\n  padding: 5px 11px;\n  border: 1px solid #e2d8c8;\n  border-radius: 16px;\n  font-size: .73rem;\n  font-weight: 600;\n  color: #6D4A2A;\n  background: linear-gradient(180deg, #fdfaf5 0%, #f8f3eb 100%);\n  cursor: pointer;\n  transition: all .2s;\n  white-space: nowrap;\n  letter-spacing: .2px;\n}\n.lbl-deco-cat-tab:hover { border-color: #D4A574; }\n.lbl-deco-cat-tab.active {\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  color: #F7E9D2;\n  border-color: transparent;\n  box-shadow: 0 2px 6px rgba(61,24,24,.2);\n}\n.lbl-deco-upload {\n  margin-bottom: 12px;\n}\n\n/* ── Decoration catalog ── */\n.lbl-deco-catalog {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-bottom: 16px;\n}\n.lbl-deco-cat-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 10px 4px 8px;\n  border: 1px solid #e2d8c8;\n  border-radius: 9px;\n  background: linear-gradient(180deg, #fdfaf5 0%, #f8f3eb 100%);\n  cursor: pointer;\n  transition: all .22s;\n}\n.lbl-deco-cat-btn:hover {\n  border-color: #D4A574;\n  background: #fff;\n  transform: translateY(-1px);\n  box-shadow: 0 3px 10px rgba(212,165,116,.18);\n}\n.lbl-deco-cat-img { width: 30px; height: 30px; object-fit: contain; }\n.lbl-deco-cat-btn span { font-size: .63rem; color: #8a7a6a; }\n\n.lbl-deco-placed { margin-bottom: 12px; }\n.lbl-deco-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border: 1px solid #e2d8c8;\n  border-radius: 7px;\n  margin-top: 4px;\n  cursor: pointer;\n  font-size: .82rem;\n  transition: all .15s;\n  background: #fdfaf5;\n}\n.lbl-deco-item:hover { background: #f8f3eb; }\n.lbl-deco-item.active { border-color: #D4A574; background: rgba(212, 165, 116, .1); }\n.lbl-deco-item-name { color: #3D1818; font-weight: 500; }\n.lbl-deco-remove {\n  border: none;\n  background: none;\n  color: #c0392b;\n  font-size: 1.1rem;\n  cursor: pointer;\n  padding: 0 4px;\n  opacity: .45;\n  transition: opacity .2s;\n}\n.lbl-deco-remove:hover { opacity: 1; }\n.lbl-deco-props { padding-top: 4px; }\n\n/* ── Text items ── */\n.lbl-text-item {\n  border: 1px solid #e2d8c8;\n  border-radius: 10px;\n  padding: 10px 12px;\n  margin-top: 10px;\n  cursor: pointer;\n  transition: all .15s;\n  background: linear-gradient(180deg, #fdfaf5 0%, #f8f4ec 100%);\n}\n.lbl-text-item:hover { background: #faf6ef; }\n.lbl-text-item.active {\n  border-color: #D4A574;\n  background: rgba(212, 165, 116, .07);\n  box-shadow: 0 2px 10px rgba(212,165,116,.15);\n}\n.lbl-text-item-head { display: flex; align-items: center; gap: 8px; }\n.lbl-text-input {\n  flex: 1;\n  border: 1px solid #e0d8cc;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: .88rem;\n  color: #3D1818;\n  background: #fff;\n  transition: border-color .2s;\n}\n.lbl-text-input:focus { outline: none; border-color: #D4A574; box-shadow: 0 0 0 2px rgba(212,165,116,.12); }\n.lbl-text-props { padding-top: 10px; }\n.lbl-text-row { display: flex; align-items: center; gap: 10px; }\n.lbl-text-toggles { display: flex; gap: 6px; margin-top: 10px; }\n.lbl-toggle-btn {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #d5c9ba;\n  border-radius: 6px;\n  background: #fff;\n  font-size: .88rem;\n  font-weight: 700;\n  color: #5D3A3A;\n  cursor: pointer;\n  transition: all .2s;\n}\n.lbl-toggle-btn:hover { border-color: #D4A574; }\n.lbl-toggle-btn.on {\n  background: linear-gradient(135deg, #3D1818 0%, #5D3A3A 100%);\n  color: #F7E9D2;\n  border-color: transparent;\n  box-shadow: 0 2px 6px rgba(61,24,24,.2);\n}\n\n/* ── Navigation ── */\n.lbl-nav {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-top: auto;\n  padding-top: 18px;\n  border-top: 1px solid #e2d8c8;\n  position: relative;\n}\n.lbl-nav::before {\n  content: '◆';\n  position: absolute;\n  top: -7px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #D4A574;\n  font-size: .55rem;\n  background: linear-gradient(180deg, #fefcf8, #faf6ef);\n  padding: 0 6px;\n}\n.lbl-nav-spacer { flex: 1; }\n\n/* ── Active decoration highlight ── */\n.lbl-deco-active { filter: drop-shadow(0 0 4px rgba(212, 165, 116, .85)); }\n\n/* ── Responsive ── */\n@media (max-width: 1024px) {\n  .lbl-main {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n    height: auto;\n  }\n  .lbl-preview-area { padding: 24px; height: auto; }\n  .lbl-preview-card { max-width: 380px; }\n  .lbl-controls {\n    border-left: none;\n    border-top: 1px solid #e2d8c8;\n    height: auto;\n    padding: 22px 24px;\n  }\n  .lbl-steps { padding: 14px 12px; gap: 0; overflow-x: auto; justify-content: flex-start; }\n  .lbl-step-line { width: 18px; }\n  .lbl-step-pill { padding: 5px 10px; }\n  .lbl-step-label { font-size: .7rem; }\n  .lbl-shape-grid { grid-template-columns: repeat(3, 1fr); gap: 8px; }\n  .lbl-brand-title { font-size: 1.05rem; letter-spacing: 2px; }\n}\n\n@media (max-width: 560px) {\n  .lbl-preview-area { padding: 16px; }\n  .lbl-controls { padding: 16px 14px; }\n  .lbl-shape-grid { grid-template-columns: 1fr 1fr; gap: 8px; }\n  .lbl-deco-catalog { grid-template-columns: repeat(4, 1fr); gap: 6px; }\n  .lbl-cartoon-grid { grid-template-columns: 1fr 1fr; }\n  .lbl-step-label { display: none; }\n  .lbl-step-pill { padding: 5px 8px; }\n  .lbl-step-line { width: 10px; }\n  .lbl-brand-orn { display: none; }\n  .lbl-brand-title { font-size: .95rem; letter-spacing: 2px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
